import React from "react";

//Stores the addresses of nominators the user selected for chilling;
export const SelectedNominatorsContext = React.createContext(null);
